import { InformationClassificationPolicy } from '../../../../insights/types/PolicyTypes';
import { MyApp } from '../../../types/myAppTypes';
import {
  BaseApplicationProperty,
  MutationStatus,
  UpdateApplicationMutationResult,
  UpdateApplicationsQuery,
} from './BaseApplicationProperty';
import { DocumentNode } from 'graphql/index';

/**
 * This class is responsible for managing the Information Classification Policy property of the application
 * @implements {BaseApplicationProperty} - This class implements the BaseApplicationProperty interface
 */
export class InformationClassificationPolicyProperty implements BaseApplicationProperty {
  field: string;
  value?: InformationClassificationPolicy;
  label: string = 'Information Classification Policy';

  /**
   * This constructor initializes the field property
   * @param field - The field property
   */
  constructor(field: string) {
    this.field = field;
  }

  /**
   * This method sets the value of the property
   * @param value - The value to set
   */
  set(value: InformationClassificationPolicy) {
    this.value = value;
  }

  /**
   * This method returns the input object for the mutation
   */
  propertyMutationInput() {
    return {
      informationClassificationPolicy: this.value?.name ?? '',
    };
  }

  /**
   * This optional method returns the current display value of the property
   * @param app - The application object
   */
  getCurrentDisplayValue(app: MyApp): string {
    return app.informationClassificationPolicy?.name || '';
  }

  /**
   * This method returns the new display value of the property
   */
  getNewDisplayValue(): string {
    return this.value?.name ?? '';
  }

  /**
   * This method returns the mutation query
   */
  mutationQuery(): DocumentNode {
    return UpdateApplicationsQuery;
  }

  /**
   * This method extracts the mutation result from the response data
   * @param data - The result data from the mutation
   */
  getMutationResult(data: UpdateApplicationMutationResult): MutationStatus[] {
    return data?.resources?.application?.updateApplications;
  }
}
